import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import CursorGlow from './CursorGlow';
import Navbar from './Navbar';
import Hero from './Hero';
import VendorSection from './VendorSection';
import FeaturesSection from './FeaturesSection';
import HighlightSection from './HighlightSection';
import CTASection from './CTASection';
import Footer from './Footer';
import MobileOnlyFooter from './MobileOnlyFooter';
import './Website.css';

function Home() {
  useEffect(() => {
    /* === Scroll-reveal for .reveal elements === */
    const revealEls = document.querySelectorAll('.website-wrapper .reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.12 });

    revealEls.forEach(el => observer.observe(el));

    /* === Smooth active nav link highlight === */
    const handleScroll = () => {
      const sections = document.querySelectorAll('.website-wrapper section, .website-wrapper header');
      const navLinks = document.querySelectorAll('.website-wrapper .nav-links a');
      let current = '';

      sections.forEach(s => {
        if (window.scrollY >= s.offsetTop - 120) {
          current = s.getAttribute('id');
        }
      });

      navLinks.forEach(a => {
        a.classList.toggle('active', a.getAttribute('href') === '#' + current);
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="website-wrapper">
      <Helmet>
        <title>Salon Management System & Software | My Salon Hub</title>
        <meta name="description" content="Streamline your beauty business with our all-in-one salon management system. Features include online booking, POS, and inventory tracking. Start a free trial!" />
      </Helmet>
      <CursorGlow />
      <Navbar />
      <Hero />
      <VendorSection />
      <FeaturesSection />
      <HighlightSection />
      <CTASection />
      <Footer />
      <MobileOnlyFooter />
    </div>
  );
}

export default Home;
